// Helper file for Storage

import { Storage } from "aws-amplify";

const localStorageImageKey = "images";

export const FetchFileFromS3 = async (key, level) => {
  let dataObj = JSON.parse(localStorage.getItem(localStorageImageKey) ?? "{}");
  const currentTime = parseInt(Date.now() / 1000);

  if (dataObj?.[key]?.validTill > currentTime) {
    return dataObj?.[key].url;
  } else {
    var url = await Storage.get(key, {
      level: level ?? "public",
      expires: 3600,
    });
    dataObj[key] = {
      url,
      validTill: currentTime + 3600,
      lastFetched: currentTime,
    };
    localStorage.setItem(localStorageImageKey, JSON.stringify(dataObj));
  }

  return url;
};
